import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ProfileCarousel } from '@bepure/tarkin';

interface CarouselProfile {
    imageUrl: string;
    text: string;
    author: string;
    qualifications?: string;
}

interface Props {
    title?: string;
    profiles: CarouselProfile[];
    button?: {
        text: string;
        link: string;
        // onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
    };
}

class ProfileCarouselSection extends React.Component<Props> {
    public render() {
        const usedButton = this.props.button ? {
                text: this.props.button.text,
                onClick: this.handleCallToAction(this.props.button.link),
        } : undefined;
        return (
            <ProfileCarousel
               title={this.props.title}
               profiles={this.props.profiles}
               button={usedButton}
            />
        );
    }

    private handleCallToAction = (link: string) => {
        return (() => {
            if (link) {
                window.location.href = link;
            }
        });
    }
}

export default function render() {
    const elements = document.getElementsByClassName('profile-carousel-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const title = element.dataset.title ? element.dataset.title : null;
        const children = Array.prototype.slice.call(element.children)
        const profiles = children.filter((child: HTMLInputElement) => child.dataset.imageurl && child.dataset.text && child.dataset.author).map((child: HTMLElement) => {
            const returnValue = {
                imageUrl: child.dataset.imageurl || '',
                text: `${child.dataset.text}` || '',
                author: child.dataset.author || '',
                qualifications: child.dataset.qualifications || '',
            } ;
            return returnValue;
        })
        const button = {
            text: element.dataset.buttontext ? element.dataset.buttontext : '',
            link: element.dataset.buttonlink ? element.dataset.buttonlink : '',
        };

        if (profiles.length > 0) {
            return ReactDOM.render(
                <ProfileCarouselSection
                    {...(title ? {title} : {})}
                    profiles={profiles}
                    {...((button && button.link && button.text) ? {button} : {})}
                />,
                element,
            );
        }
    });
}
